import createLucideIcon from '../createLucideIcon';

const ArrowBigLeft = createLucideIcon('ArrowBigLeft', [
  ['path', { d: 'M18 15h-6v4l-7-7 7-7v4h6v6z', key: 'lbrdak' }],
]);

export default ArrowBigLeft;
